export default __webpack_public_path__ + "static/step_4_ru-4d4d1cd5eb16d67bb4e7ecf087dbca6b.svg";